import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import HelmetWrapper from "../../HelmetWrapper";
import { fetchWorkoutGoalData } from "../../redux/website-reducers/websiteSlice";
import { selectAuth } from "../../components/auth/auth.selector";
import AllGoals from "../../components/website-contents/workout-goals/AllGoals";
import SearchNButtons from "../../components/common-components/SearchNButtons";
import MealsStructure from "../../components/diet/meal/MealsStructure";

const WorkoutGoals = () => {
  const dispatch = useDispatch();
  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;

  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    description: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);
  const [isPage, setIsPage] = useState(0);
  const iniAllFilter = {
    searchString: "",
    isActive: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    limit: 10,
    page: isPage + 1,
    status: allFilters.isActive?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  // function onResetFilters() {
  //   setAllFilters(iniAllFilter);
  //   setFilters(iniFilters);
  //   setSearchFilterApplied(false);
  //   setIsPage(0);
  // }

  function onCloseModalvalues() {
    setModValues(iniModvalues);
  }

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
      setIsPage(0);
    }
  };

  function getGoals(filters) {
    dispatch(
      fetchWorkoutGoalData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      status: allFilters.isActive?.value || "",
    }));
  }, [isPage, allFilters.isActive]);

  useEffect(() => {
    getGoals(filters);
  }, [filters]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Workout Goals">
      <Container className="bg-cloud-k px-50px" fluid>
        <Row>
          <Col>
            <MealsStructure text={"Workout Goal"} />
          </Col>
        </Row>

        <br />

        <Row>
          <Col>
            <SearchNButtons
              pageName={"workout-goal"}
              filters={allFilters}
              setFilters={setAllFilters}
              searchFilterApplied={searchFilterApplied}
              onClickSearch={onClickSearch}
              btnText={"+ Add new"}
              onClickAdd={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "add",
                }))
              }
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <AllGoals
              isPage={isPage}
              setIsPage={setIsPage}
              callFunction={() => {
                getGoals(filters);
              }}
              userInfoData={userInfoData}
              modValues={modValues}
              setModValues={setModValues}
              onCloseModalvalues={onCloseModalvalues}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default WorkoutGoals;
